import { FC, useCallback, useEffect, useState } from "react";
import styled from "@emotion/styled";
import popupActivityService from "src/module/popupActivity/service";
import { IndexPopupEntity } from "../../../module/indexPopup/entity/indexPopupEntity";
import { Button, message, Space, Table, Modal } from "antd";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";

export const PopupList: FC = () => {
	const { confirm } = Modal;
	const navigate = useNavigate();
	const { t } = useTranslation();

	const [dataList, setDataList] = useState<IndexPopupEntity[]>([]);
	const columns = [
		{
			title: "id",
			dataIndex: "id",
		},
		{
			title: "客户类型",
			render: (record: any) => {
				return record.type === 1 ? "会员客户" : "非会员客户";
			},
		},
		{
			title: "弹窗类型",
			render: (record: any) => {
				return record.popupType === 1 ? "优惠券" : record.popupType === 2 ? "会员卡" : "问候语";
			},
		},
		{
			title: t("startTime"),
			dataIndex: "startAt",
		},
		{
			title: t("endTime"),
			dataIndex: "expiredAt",
		},
		{
			title: "Group",
			dataIndex: "rfmGroup",
		},
		{
			title: "offer",
			dataIndex: "offer",
		},

		{
			title: t("action"),
			render: (record: any) => {
				return (
					<Space>
						<Button
							type='primary'
							onClick={() => {
								navigate("/activity/popup/" + record.id);
							}}
						>
							{t("edit")}
						</Button>
						<Button
							type='primary'
							danger
							onClick={() => {
								deleteRecord(record.id);
							}}
						>
							{t("delete")}
						</Button>
					</Space>
				);
			},
		},
	];

	const init = useCallback(async () => {
		const { data } = await popupActivityService.list();
		setDataList(data.data);
	}, []);
	useEffect(() => {
		init();
	}, [init]);

	const deleteRecord = async (id: number) => {
		confirm({
			title: "警告",
			content: "确认删除此弹窗吗",
			okType: "danger",
			onOk: async () => {
				const { data } = await popupActivityService.delete(id);
				if (data.code === 200) {
					message.success(t("success"));
					init();
				} else message.error(data.msg);
			},
		});
	};

	return (
		<Container>
			<Space>
				<Button
					type='primary'
					onClick={() => {
						navigate("/activity/popup/0");
					}}
				>
					{t("add")}
				</Button>
			</Space>
			<Table columns={columns} dataSource={dataList} rowKey={(record) => record.id + ""} style={{ marginTop: 20 }} pagination={false} />
		</Container>
	);
};

const Container = styled.div`
	width: 100%;
	padding: 20px;
`;
